<template>
  <v-container>
    <v-row class="top-bar"><v-btn @click="back()" text>&lt; Back To {{from || 'DEALS'}}</v-btn></v-row>
    <cloud-mining :item="product" />
    <cloud-mining-detail :item="product" />
    <sensitivity-table :item="product" />

    <share-footer :item="product" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CloudMining from "@/components/product/CloudMining";
import CloudMiningDetail from "@/components/product/CloudMiningDetail";
import SensitivityTable from "@/components/SensitivityTable";
import ShareFooter from "@/components/ShareFooter";

export default {
  name: "ProductView",
  components: { CloudMining, CloudMiningDetail, SensitivityTable, ShareFooter },
  methods: {
    back() { history.back(); }
  },
  computed: {
    ...mapGetters("cloudMining", ["getContractById"]),
    product() {
      const { id, coin } = this.$route.query;
      return this.getContractById(id, coin);
    }
  },
  data() {
    const { from, id, coin } = this.$route.query;
    return {
      from,
      id,
      coin
    };
  }
}
</script>

<style scoped lang="scss">
.container {
  padding-top: 0!important;
}

.top-bar {
  border-bottom: 1px solid lightgrey;
  margin-bottom: 10px;
}
</style>